import { BookingStatus } from '../enum/booking-status';

export const BookingStatusMap: Record<number, string> = {
    [BookingStatus.CONFIRMED_QUICK]: 'booking.displayStatus.confirmed',
    [BookingStatus.CONFIRMED_BY_HOST]: 'booking.displayStatus.confirmed',
    [BookingStatus.CONFIRMED_BY_SYSTEM]: 'booking.displayStatus.confirmed',
    [BookingStatus.CANCELLED_BY_HOST]: 'booking.displayStatus.declined',
    [BookingStatus.CANCELLED_BY_USER]: 'booking.displayStatus.cancled',
    [BookingStatus.CANCELLED_BY_SYSTEM]: 'booking.displayStatus.declined',
    [BookingStatus.PENDING_CONFIRMATION_BY_HOST]:
        'booking.displayStatus.paindingConfirmation',
    [BookingStatus.PENDING_CAPTURE_MONEY]: 'booking.displayStatus.confirmed',
    [BookingStatus.COMPLETED]: 'booking.displayStatus.completed',
    [BookingStatus.EXPIRED]: 'booking.displayStatus.expired',
    [BookingStatus.FAILED]: 'booking.displayStatus.failed',
    [BookingStatus.NO_SHOW]: 'booking.displayStatus.noShow'
};

export const BookingStatusTextColor: Record<number, string> = {
    [BookingStatus.CONFIRMED_QUICK]: 'text-success',
    [BookingStatus.CONFIRMED_BY_HOST]: 'text-success',
    [BookingStatus.CONFIRMED_BY_SYSTEM]: 'text-success',
    [BookingStatus.CANCELLED_BY_HOST]: 'text-danger',
    [BookingStatus.CANCELLED_BY_USER]: 'text-orange',
    [BookingStatus.CANCELLED_BY_SYSTEM]: 'text-danger',
    [BookingStatus.PENDING_CONFIRMATION_BY_HOST]: 'text-primary',
    [BookingStatus.PENDING_CAPTURE_MONEY]: 'text-success',
    [BookingStatus.COMPLETED]: 'text-success',
    [BookingStatus.EXPIRED]: 'text-muted',
    [BookingStatus.FAILED]: 'text-muted',
    [BookingStatus.NO_SHOW]: 'text-danger'
};
export const BookingStatusBgColor: Record<number, string> = {
    [BookingStatus.CONFIRMED_QUICK]: 'bg-hot-success',
    [BookingStatus.CONFIRMED_BY_HOST]: 'bg-hot-success',
    [BookingStatus.CONFIRMED_BY_SYSTEM]: 'bg-hot-success',
    [BookingStatus.CANCELLED_BY_HOST]: 'hot-pinkish',
    [BookingStatus.CANCELLED_BY_USER]: 'hot-pinkish',
    [BookingStatus.CANCELLED_BY_SYSTEM]: 'hot-pinkish',
    [BookingStatus.PENDING_CONFIRMATION_BY_HOST]: 'bg-hot-primary',
    [BookingStatus.PENDING_CAPTURE_MONEY]: 'bg-hot-success',
    [BookingStatus.COMPLETED]: 'bg-hot-success',
    [BookingStatus.EXPIRED]: 'bg-expired',
    [BookingStatus.FAILED]: 'bg-expired',
    [BookingStatus.NO_SHOW]: 'hot-pinkish'
};
export const UpcommingAndOnGoingStatus = [
    BookingStatus.CONFIRMED_BY_HOST,
    BookingStatus.CONFIRMED_BY_SYSTEM,
    BookingStatus.CONFIRMED_QUICK,
    BookingStatus.PENDING_CAPTURE_MONEY
];

export const OtherStatus = [
    BookingStatus.COMPLETED,
    BookingStatus.EXPIRED,
    BookingStatus.CANCELLED_BY_USER,
    BookingStatus.CANCELLED_BY_SYSTEM,
    BookingStatus.CANCELLED_BY_HOST,
    BookingStatus.FAILED,
    BookingStatus.NO_SHOW
];

export const CancelStatus = [
    BookingStatus.CANCELLED_BY_USER,
    BookingStatus.CANCELLED_BY_SYSTEM,
    BookingStatus.CANCELLED_BY_HOST
];
